import { Choice } from 'entities/choice'
import { ReagentItem } from 'entities/reagent_item'
import { Tag } from 'entities/tag'
import { TaskSet } from 'entities/task_set'
import { UserGroup } from 'entities/user_group'
import React from 'react'

type MasterData = {
    probeTags: Tag[]
    choices: Choice[]
    reagentItems: ReagentItem[]
    taskSets: TaskSet[]
    userGroups: UserGroup[]
    reloadChoices: () => void
    reloadReagentItems: () => void
    reloadTaskSets: () => void
}

export const initialMasterData: MasterData = {
    probeTags: [],
    choices: [],
    reagentItems: [],
    taskSets: [],
    userGroups: [],
    reloadChoices: () => {},
    reloadReagentItems: () => {},
    reloadTaskSets: () => {},
}

export const MasterDataContext = React.createContext(initialMasterData)
